<template>
  <DialogTemplateToolkit
    data-qa="dialog-invite-participation"
    :dialog="dialog"
    :disabled="onlyOverLimit || nothingToSendOnAction"
    first_btn="Tenders.Invite"
    :loading="loading"
    :title="$t('Tenders.InviteNewSuppliers')"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <slot
        name="activator"
        :open="open">
        <TooltipedBtn
          v-if="one_more"
          class="invite-new-participation-dialog__btn"
          :color="!disabled ? 'var(--black-color)' : 'grey'"
          data-qa="btn-inviteAnother"
          :disabled="disabled"
          hint-max-width="280px"
          hint-qa="btn-inviteAnother"
          icon="invite"
          :small-btn="true"
          :text="$t('Tenders.InviteAnother')"
          :texted="$vuetify.breakpoint.xlAndUp"
          @click="dialog = true">
          <template
            v-if="limitHintShown"
            #text>
            <div>{{ $t('Tenders.InviteAnother') }}</div>
            <div>{{ $_unknownEmailsLimitHint }}</div>
          </template>
        </TooltipedBtn>
        <sTooltip
          v-else-if="limitHintShown"
          :border="false"
          :content="$_unknownEmailsLimitHint"
          :enterable="false"
          placement="bottom"
          type="white">
          <sButton
            class="invite-new-participation-dialog__btn"
            data-qa="btn-inviteAnother_new"
            icon="plus"
            icon-size="12px"
            type="border"
            @click="dialog = true">
            {{ $t('Tenders.InviteNew') }}
          </sButton>
        </sTooltip>
        <sButton
          v-else
          class="invite-new-participation-dialog__btn"
          data-qa="btn-inviteAnother_new"
          icon="plus"
          icon-size="12px"
          type="border"
          @click="dialog = true">
          {{ $t('Tenders.InviteNew') }}
        </sButton>
      </slot>
    </template>
    <template #card-text>
      <div class="invite-new-participation-dialog">
        <sAlert
          v-if="limitHintShown"
          class="mb-4"
          data-qa="invite-limit-hint"
          small>
          {{ $_unknownEmailsLimitHint }}
        </sAlert>
        <CustomTextarea
          id="invite-suppliers-textarea"
          autofocus
          :class="{'error-color': error}"
          data-qa="invite-suppliers-textarea"
          :disabled="loading"
          :error.sync="error"
          :error_text="error_text"
          :placeholder="!mails.length ? $t('Tenders.EnterEmailParticipants') : ''"
          rounded
          rows="5"
          show_details
          :value.sync="text"
          @keydown_enter="getMail(text)"
          @paste="val => getMail(val)">
          <template #area-prepend-inner>
            <v-chip
              v-for="(item, count) in mails"
              :key="count"
              class=" mail-chip mt-2 mr-2 pr-0"
              :class="item.blockDomen || item.invalid || (to_action && item.not_registered) || isOverLimit(item) ? 'secondary__red' : 'main__green' "
              :data-qa="`mail-${count}`"
              :disabled="loading">
              <div
                class="flex"
                :style="!item.userName || item.userName === item.email ? 'padding: 10px 0;' : ''">
                <InfoIconWithTooltip
                  v-if="item.blockDomen"
                  class="mr-2"
                  :content="$t('Common.mailDomenBlocked')"
                  type-tooltip="dark"/>
                <InfoIconWithTooltip
                  v-if="item.invalid"
                  class="mr-2"
                  :content="invalidReasonText(item)"
                  type-tooltip="dark"/>
                <InfoIconWithTooltip
                  v-if="isOverLimit(item)"
                  class="mr-2"
                  :content="$t('Tenders.UnknownEmailsOverLimitChip')"
                  :data-qa="`mail-${count}-limit-icon`"
                  type-tooltip="dark"/>
                <div
                  v-if="item.userName && item.userName !== item.email"
                  class="pr-1"
                  style="white-space: nowrap;">
                  {{ item.userName }}
                </div>
                <div style="white-space: nowrap;">
                  {{ item.email }}
                </div>
              </div>
              <div
                @click="cancelMail(item)">
                <sIcon
                  class="pointer mx-2"
                  color="#779593"
                  :data-qa="`mail-${count}-close`"
                  size="10"
                  type="cross"/>
              </div>
            </v-chip>
          </template>
        </CustomTextarea>
        <div
          v-if="overLimitEmails.size || backendLimitRejected"
          class="invite-new-participation-dialog__over-limit"
          data-qa="invite-limit-exceeded">
          {{ $t('Tenders.UnknownEmailsOverLimitMessage', { limit: $_unknownEmailsLimit }) }}
        </div>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import CustomTextarea from 'components/common/inputs/CustomTextarea.vue'
import InfoIconWithTooltip from 'components/common/elements/InfoIconWithTooltip.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { ParticipantsGroup, ParticipantUser, ParticipantUsers } from '@/types/participants.js'
import { tenderMixin } from 'mixins'
import { rejectionMessage } from '@/helpers/emailRejections.js'
import { overLimitEmails, collectInvitedUnregistered, normalizeEmail } from '@/helpers/unknownEmailsLimit.js'
import unknownEmailsLimitMixin from '@/mixins/unknownEmailsLimitMixin.js'

// OLD
//const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gm
// For debug https://regex101.com/r/JTgz4X/2
// const pattern = /(?:[\^"'`\s]*|(?<name>\w+(?:[,.\s]+\w+)*)?["'`\s<]+)(?<mail>\S+@[\w.-]+\.[a-zA-Z]+\s)/gm
// const pattern = text ?
//   /(?:[\^"'`\s]*|(?<name>\w+(?:[,.:\s]+\w+)*)?["'`:\s<]+)(?<mail>\S+@[\w.-]+\.[a-zA-Z]+\s)/gm
//   : /(?:[\^"'`\s]*|(?<name>\w+(?:[,.:\s]+\w+)*)?["'`:\s<]+)(?<mail>\S+@[\w.-]+\.[a-zA-Z]+\b)/gm
// https://regex101.com/r/JTgz4X/6  https://regexr.com/
const pattern = new RegExp('(?:["\'`\\s]*|(?<name>\\w+(?:[,\\.:\\s]+\\w+)*)?["\'`:\\s<]+)(?<mail>[\\w\\-\\_\\.]+@[\\w\\-\\.]+\\.[a-zA-Z]+\\b)', 'gm')
// has_email_pattern = /(?:["'`\s]*|(?<name>\w+(?:[-,.:\s]+\w+)*)?["'`:\s<]+)(?<mail>[\w.-]+@[\w.-]+\.[a-zA-Z]+)/gm
export default {
  name: 'inviteNewParticipation',
  mixins: [ tenderMixin, unknownEmailsLimitMixin ],
  data() {
    return {
      dialog: false,
      loading: false,
      text: '',
      error: false,
      mails: [],
      timeout: 0,
      error_text: '',
      backendLimitRejected: false
    }
  },
  computed: {
    /**
     * Множина K: уже запрошені незареєстровані (з пропа invited)
     */
    invitedUnregisteredSet() {
      return collectInvitedUnregistered(this.invited)
    },
    /**
     * Нормалізовані email понад ліміт. Порожня, якщо ліміт вимкнено або етап 7 (to_action):
     * там незареєстровані вже червоні з помилкою NotRegisteredCanNotBeInvited, друга позначка не потрібна
     */
    overLimitEmails() {
      if (!this.$_unknownEmailsLimitActive || this.to_action) {
        return new Set()
      }
      return overLimitEmails(this.mails, this.$_unknownEmailsLimit, this.invitedUnregisteredSet)
    },
    /**
     * Є контакти понад ліміт і жодного, що буде відправлений, а в полі немає нового тексту:
     * відправляти нічого, тому кнопка «Запросити» неактивна
     */
    onlyOverLimit() {
      return !!this.overLimitEmails.size
        && !this.text?.trim()
        && !this.mails.some(i => !i.blockDomen && !i.invalid && !this.isOverLimit(i))
    },
    /**
     * Підказка про ліміт (тултіп кнопки й текст у діалозі). На етапі 7 (to_action) незареєстрованих
     * запросити не можна взагалі, тому ліміт там не показується
     */
    limitHintShown() {
      return this.$_unknownEmailsLimitActive && !this.to_action
    },
    /**
     * Етап 7: немає жодного контакту, який буде відправлений (незареєстровані, невалідні,
     * заблоковані не відправляються), а в полі немає нового тексту — кнопка «Запросити» неактивна
     */
    nothingToSendOnAction() {
      return this.to_action
        && !this.text?.trim()
        && !this.mails.some(i => this.isSendable(i))
    },
  },
  props: {
    invited: {
      type: Array,
      default: () => { return [] }
    },
    applyFunc: Function,
    setInvited: Function,
    one_more: Boolean,
    disabled: Boolean,
    to_action: Boolean
  },
  methods: {
    /**
     * Анализ строки и поиск данных по почте
     */
    async getMail(text) {
      this.error_text = ''
      this.error = false
      if (!text) {
        return
      }

      if (text.match(/@[\w.]+@[\w.]+\s/gm) ) {
        this.error_text = this.$t('Tenders.MailRules', {mail: ''})
        this.error = true
        return
      }
      const textForParse = `${text || this.text}`.toLowerCase()

      const parseResult = {
        ret: [...textForParse.matchAll(pattern)],
        substitution: textForParse.replace(pattern, '')
      }

      var ret = parseResult.ret.filter((i) => !this.mails.find(mailObject => mailObject.email === i[0]))

      if (ret?.length) {
        this.loading = true
      } else {
        this.loading = false
        return
      }
      let ret2 = this.$_.map(ret, match =>
        ParticipantUser.InviteParticipantUser(match[2], match[1]))
      let matches = new ParticipantUsers(ret2)
      await matches.checkRegistrations()

      matches = this.$_checkRuEmailDomen(matches.all)

      if (matches?.length) {
        matches.forEach(emailObject => {
          if (!this.mails.find(i => i.email === emailObject.email)) {
            this.mails.push(emailObject)
          }
        })
        this.getNotRegistred()
      }
      this.text = parseResult.substitution
      if (this.text?.trim().replace(/[^a-zA-Z0-9 ]/g, '')) {
        this.error = true
        this.error_text = this.$t('Validate.NeedEmails')
      }
      this.loading = false
    },
    invalidReasonText(item) {
      return rejectionMessage({ email: item.email, reason: item.invalidReason, suggestion: item.suggestion }, this.$t.bind(this))
    },
    isOverLimit(item) {
      return this.overLimitEmails.has(normalizeEmail(item.email))
    },
    /**
     * Контакт потрапляє в payload: не невалідний, не із заблокованого домену, не понад ліміт,
     * а на етапі 7 (to_action) — ще й зареєстрований
     */
    isSendable(item) {
      return !item.blockDomen && !item.invalid && !this.isOverLimit(item) && !(this.to_action && item.not_registered)
    },
    getNotRegistred() {
      this.error_text = this.$t('Tenders.NotRegisteredCanNotBeInvited')
      this.error = this.to_action && !!this.mails.length && this.mails.some(el => el.not_registered)
    },
    cancelMail(item) {
      this.mails = this.mails.filter(el => el != item)
      this.getNotRegistred()
    },
    async apply() {
      this.backendLimitRejected = false
      await this.getMail(this.text)
      if (!this.mails?.length) {
        this.error_text = this.$t('Common.NeedMinOneMail')
        this.error = true
        return
      }
      // на етапі 7 помилка про незареєстрованих не блокує відправку: вони просто не потрапляють у payload
      if (this.error && this.error_text !== this.$t('Tenders.NotRegisteredCanNotBeInvited')) {
        return
      }
      if (this.to_action && !this.mails.some(i => this.isSendable(i))) {
        // етап 7 і немає жодного валідного контакту: нічого не відправляємо, діалог лишається відкритим
        this.getNotRegistred()
        return
      }

      if (this.$_unknownEmailsLimitActive) {
        await this.applyWithLimit()
        return
      }

      this.mails = this.$_getUnicByEmail(this.mails).filter(i => this.isSendable(i))

      if (this.applyFunc) {
        this.applyFunc(this.mails)
      } else {
        this.setInvited(this.mails).then(() => this.addToDraft(this.mails))
      }
      this.close()
    },
    /**
     * Відправка при активному ліміті: червоні за лімітом не відправляються, `this.mails` не чіпаємо,
     * щоб при відмові бекенду діалог лишився з усіма контактами.
     */
    async applyWithLimit() {
      const payload = this.$_getUnicByEmail(this.mails).filter(i => this.isSendable(i))

      if (!payload.length && this.overLimitEmails.size) {
        // усі контакти червоні за лімітом: нічого не відправляємо, діалог лишається відкритим
        return
      }

      this.loading = true
      try {
        const result = this.applyFunc
          ? await this.applyFunc(payload)
          : await this.setInvited(payload)
        if (result?.limitRejected) {
          this.backendLimitRejected = true
          return
        }
        if (!this.applyFunc) {
          this.addToDraft(payload)
        }
      } finally {
        this.loading = false
      }
      this.close()
    },
    /**
     * Додає запрошених у групу-чернетку: створює її, якщо ще немає
     * @param {Array} users
     */
    addToDraft(users) {
      let draft = this.invited.find(i => i.draft)
      if (!draft) {
        draft = ParticipantsGroup.Draft(this.$t('Tenders.InvitedDraft'))
        draft.users.unshift(...users)

        const result = this.$_.cloneDeep(this.invited)
        result.unshift(draft)

        this.$emit('update:invited', result)
      } else {
        draft.users.unshift(...users)
        draft.users = this.$_getUnicByEmail(draft.users)
      }
    },
    close() {
      this.backendLimitRejected = false
      this.text = ''
      this.error = false
      this.dialog = false
      this.mails = []
    },
    open() {
      setTimeout(() => this.dialog = true, 100)
    }
  },
  components: {
    TooltipedBtn,
    CustomTextarea,
    InfoIconWithTooltip,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss">
#invite-suppliers-textarea {
  & .v-input.custom-textarea.rounded fieldset {
    border-radius: 8px !important;
  }
}
.invite-new-participation-dialog__btn {
  height: 40px;
}
.invite-new-participation-dialog {
  & .invite-new-participation-dialog__over-limit {
    color: var(--v-secondary__red-base);
  }
  & .error-color textarea{
    color: var(--v-secondary__red-base) !important;
  }
  & .v-input__slot, .v-input__prepend-inner {
    align-items: flex-start;
    flex-wrap: wrap;
    z-index: 10;
  }
  & .v-input__prepend-inner {
    margin: 0;
  }
  & .mail-chip {
    height: min-content;
    max-width: 100%;
    width: min-content;
    white-space: normal;
  }
  & .custom-textarea .v-text-field__slot {
    width: 100%;
  }
  & textarea {
    margin-top: 10px !important;
  }
}
</style>
